import { Message } from 'primereact/message';
import { useLanguageContext } from '../../contexts/LanguageContext';

function TranslationWarning() {
  const { currentLanguage } = useLanguageContext();

  if (currentLanguage.code === 'fr') return null;
  return (
    <Message
      severity="warn"
      text="Pensez à vérifier que tous les champs sont correctement traduits. Si un champs n'a pas encore de traduction, c'est la version française qui s'affichera par défaut. "
      className="w-fit"
    />
  );
}

export default TranslationWarning;
